import { BasicAtomsLogicTypes, LogicType_And, LogicType_Complex, rangeRightHandOperators, uniqueIdsRightHandOperators } from '@app/hcs-shared';
import { exists } from '@nu-art/ts-common';
export const rightHand_isRange = (_case) => {
    const caseOperator = _case.get('caseOperator');
    if (!caseOperator)
        return false;
    return rangeRightHandOperators.includes(caseOperator);
};
export const rightHand_isValue = (_case) => {
    const caseOperator = _case.get('caseOperator');
    if (!caseOperator)
        return false;
    return uniqueIdsRightHandOperators.includes(caseOperator);
};
export const term_isFlat = (_term) => {
    const atomsLogic = _term.get('atomsLogic');
    if (!atomsLogic)
        return false;
    return BasicAtomsLogicTypes.includes(atomsLogic);
};
export const editableTerm_isWithSubTerms = (_term) => {
    const atomsLogic = _term.get('atomsLogic');
    const subTerms = _term.get('subTerms');
    if (!atomsLogic)
        return false;
    return atomsLogic === LogicType_Complex && exists(subTerms);
};
export const term_isWithSubTerms = (_term) => {
    return _term.atomsLogic === LogicType_Complex;
};
export const getEmptyTerm = () => {
    return {
        expression: 'A1',
        atomsLogic: LogicType_And,
        atoms: [{ leftHand: undefined, cases: [{ rightHand: [] }] }],
    };
};
export const TermsOutput_IsNumeric = (term) => {
    if (term.atomsLogic === LogicType_Complex)
        return true;
    if (exists(term.value))
        return true;
    if (term.outputType === 'numeric')
        return true;
    return term.atoms.every(atom => {
        if (exists(atom.cases[0].value))
            return true;
        return atom.cases[0].valueType === 'numeric';
    });
};
export const TermOutput_IsBoolean = (term) => {
    if (term.atomsLogic === LogicType_Complex)
        return false;
    if (exists(term.value))
        return false;
    if (term.outputType === 'boolean')
        return true;
    return !term.atoms.every(atom => exists(atom.cases[0].value)
        || atom.cases[0].valueType === 'numeric' || atom.cases[0].valueType === 'enum');
};
export const term_isFlatTerm = (_term) => {
    return _term.atomsLogic !== LogicType_Complex;
};
//# sourceMappingURL=utils.js.map